<div class="uk-grid">
    <div class="uk-width-1-1 navbar">
        <p class="nav-text">
            {{'parcels' | translate}}
            <button class="uk-button uk-button-primary padding-horizontal-small button-opt"
                    routerLink="/shipment/new"
                    *ngIf="userModel.role != UserRole.warehouse_worker"
                    [attr.uk-tooltip]="'Dodaj przesyłkę'"
            >
              <span uk-icon="plus"></span>
            </button>
          <a class="uk-button uk-button-primary padding-horizontal-small button-opt uk-margin-remove-right"
             *ngIf="userModel.role === UserRole.admin || userModel.role === UserRole.client"
             (click)="downloadFile()"
             [attr.uk-tooltip]="'Pobierz zestawienie'"
          >
            <span uk-icon="file-text"></span>
          </a>

            <a class="uk-button uk-button-primary padding-horizontal-small button-opt uk-margin-remove-right"
               *ngIf="userModel?.role === UserRole.admin && 'parcels' === criteria.type"
               [attr.uk-tooltip]="'Zmień statusy'"
               (click)="openGroupedStatus()"
            >
              <span uk-icon="commenting"></span>
            </a>
            <a class="uk-button uk-button-primary padding-horizontal-small button-opt uk-margin-remove-right"
               *ngIf="userModel?.role === UserRole.admin && 'parcels' === criteria.type"
               (click)="selectAll()"
               [attr.uk-tooltip]="lastChecked ? 'Odznacz przesyłki' : 'Zaznacz przesyłki'"
            >
              <span uk-icon="check"></span>
            </a>
            <a class="uk-button uk-button-primary padding-horizontal-small button-opt uk-margin-remove-right"
               [attr.uk-tooltip]="'Resetuj filtry'"
               (click)="refreshFilters()"
            >
              <span uk-icon="refresh"></span>
            </a>
        </p>
    </div>
    <div class="uk-width-1-1 inner-shadow">
      <div
        style="margin-left: -30px!important; margin-bottom: 100px !important; margin-right: -30px!important;"
        class="uk-card uk-card-default uk-card-body uk-margin-small-right uk-margin-small-top uk-padding-small">
        <div class="mobile-overflow">
          <div class="uk-grid">
            <div class="uk-width-1-5">
              <div class="uk-grid">
                <div class="uk-width-1-2">
                  <label>Rodzaj listy</label>
                  <select class="uk-select" [(ngModel)]="criteria.type">
                    <option value="parcels">Przesyłki</option>
                    <option value="shipments">Listy przewozowe</option>
                  </select>
                </div>
                <div class="uk-width-1-2">
                  <label title="Rodzaj przesyłek">R. przesyłek</label>
                  <select class="uk-select" [(ngModel)]="criteria.deleted">
                    <option value="0">Aktywne</option>
                    <option value="1">Usunięte</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="uk-width-1-5">
              <div class="uk-grid">
                <div class="uk-width-1-2@m">
                  <label>Paczkomat</label>
                  <select class="uk-select" [(ngModel)]="criteria.locker">
                    <option value="">Nie wybrano</option>
                    <option value="1">Tak</option>
                    <option value="0">Nie</option>
                  </select>
                </div>
                <div class="uk-width-1-2@m">
                  <label>Pobranie</label>
                  <select class="uk-select" [(ngModel)]="criteria.cod">
                    <option value="">Nie wybrano</option>
                    <option value="1">Tak</option>
                    <option value="0">Nie</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="uk-width-1-5">
              <div class="uk-grid">
                <div class="uk-width-1-2@m">
                  <label>{{'from' | translate}}</label>
                  <input type="date" name="search-from" [(ngModel)]="criteria.start" class="uk-input">
                </div>
                <div class="uk-width-1-2@m">
                  <label>{{'to' | translate}}</label>
                  <input type="date" name="search-to" [(ngModel)]="criteria.end" class="uk-input">
                </div>
              </div>
            </div>
            <div class="uk-width-1-5">
              <label>Status</label>
              <select class="uk-select" [(ngModel)]="criteria.status_group_id">
                <option value="">Nie wybrano</option>
                <option *ngFor="let statusGroup of statusGroups" value="{{statusGroup.id}}">{{statusGroup.name}}</option>
              </select>
            </div>
            <div class="uk-width-1-5" style="padding-right: 30px !important;">
              <br>
              <button class="uk-button uk-button-primary uk-width-1-1" (click)="runFilters()">
                Filtruj
              </button>
            </div>
            <div class="uk-width-1-6">
              <label *ngIf="UserRole.client !== userModel?.role">Numer wewnętrzny</label>
              <label *ngIf="UserRole.client === userModel?.role">Numer przesyłki</label>
              <input class="uk-input" [(ngModel)]="criteria.internal_number">
            </div>
            <div class="uk-width-1-6">
              <label>Numer wyjściowy</label>
              <input class="uk-input" [(ngModel)]="criteria.out_number">
            </div>
            <div class="uk-width-1-2">
              <div class="uk-grid">
                <div class="uk-width-1-3" *ngIf="userModel?.role < UserRole.client">
                  <label>Numer zwrotny</label>
                  <input class="uk-input" [(ngModel)]="criteria.return_number">
                </div>
                <div class="uk-width-1-3" *ngIf="userModel?.role < UserRole.client">
                  <label>Klient</label>
                  <input autocomplete="off" [class.uk-form-danger]="clientInput.touched && id_client.value == ''" (keyup)="searchClient(clientInput)" type="text" #clientInput="ngModel" name="client" [(ngModel)]="criteria.client_name" class="uk-input" required #clientField>
                  <div style="position: absolute; max-height: 200px;" class="uk-overflow-auto">
                    <ul class="uk-list uk-list-divider uk-position-relative uk-margin-remove-top" style="background-color: white; width: 100%;" *ngIf="clients.length > 0" [style.width]="clientField.clientWidth + 'px'">
                      <li *ngFor="let client of clients" (click)="setClient(client);" style="padding-left: 5px!important;">{{client.name}}</li>
                    </ul>
                  </div>
                  <input type="hidden" #id_client="ngModel" autocomplete="none" [(ngModel)]="criteria.client_id"  class="uk-input">
                </div>
                <div class="uk-width-1-3">
                  <label>Kraj</label>
                  <select class="uk-select" [(ngModel)]="criteria.country">
                    <option value="">Nie wybrano</option>
                    <option *ngFor="let country of countries" value="{{country.value}}">{{country.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="uk-width-1-6" style="padding-right: 30px !important;" *ngIf="userModel?.role < UserRole.client && 'parcels' === criteria.type">
              <label>Procesowalna</label>
              <select class="uk-select" [(ngModel)]="criteria.processable">
                <option value=""></option>
                <option value="1">Tak</option>
                <option value="0">Nie</option>
              </select>
            </div>

            <div *ngIf="userModel.role < UserRole.client" class="uk-width-1-1@m uk-margin-top">
              <ul class="mobile-overflow uk-accordion" uk-accordion>
                <li class="uk-close">
                  <p class="uk-accordion-title uk-heading-divider" href="#" [title]="'Pozostałe informacje służące diagnostyce'">Dodatkowe filtry...</p>
                  <div class="uk-accordion-content">
                    <div class="uk-grid">
                      <div class="uk-width-1-4" *ngIf="userModel?.role < UserRole.client">
                        <label>Wybór klientów</label>
                        <input autocomplete="off"(keyup)="searchClientToList(clientListInput)" type="text" [(ngModel)]="clientListClientName" #clientListInput="ngModel" name="client" class="uk-input" required #clientListField ngModel>

                        <div style="position: absolute; max-height: 200px;" class="uk-overflow-auto">
                          <ul class="uk-list uk-list-divider uk-position-relative uk-margin-remove-top" style="background-color: white; width: 100%;" *ngIf="listClients.length > 0" [style.width]="clientListField.clientWidth + 'px'">
                            <li *ngFor="let client of listClients" (click)="addSelectedClients(client);" style="padding-left: 5px!important;">{{client.name}}</li>
                          </ul>
                        </div>

                        <div class="uk-grid">
                          <div class="uk-width-1-1 pt-10 " *ngFor="let selectedClient of selectedClients; let x = index">
                            <input type="checkbox" checked (change)="uncheckClientFromList(x)" class="pr-20">{{selectedClient.name}}
                          </div>
                        </div>
                      </div>

                      <div class="uk-width-1-4" *ngIf="userModel?.role < UserRole.client">
                        <label>Rodzaj wyszukiwania klientów</label>
                        <select class="uk-select" [(ngModel)]="criteria.client_list_filter_mode" name="client_list_filter_type">
                          <option value="include">Wybierz</option>
                          <option value="exclude">Wyklucz</option>
                        </select>
                      </div>

                      <div class="uk-width-1-4" *ngIf="userModel?.role == UserRole.admin">
                        <label>Reguła nieprawidłowości</label>
                        <select class="uk-select" [(ngModel)]="criteria.problem_rule_code">
                          <option value=""></option>
                          <option *ngFor="let rule of problemRuleCodes" value="{{rule.code}}">{{rule.name}}</option>
                        </select>
                      </div>

                      <div class="uk-width-1-4"
                           *ngIf="userModel?.role < UserRole.client && 'parcels' === criteria.type"
                           style="padding-right: 30px !important;"
                      >
                        <label>Sektor przesyłek problematycznych</label>
                        <select class="uk-select" [(ngModel)]="criteria.problematic_sector_id">
                          <option value=""></option>
                          <option *ngFor="let sector of problematicSectors" value="{{sector.id}}">{{sector.name}} [{{sector.code}}]</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <br>

          <app-shipments-list
            #shipmentsListDatatables
            [userRole]="userModel?.role"
            [criteria]="criteria"
            [lengthMenu]="lengthMenu"
            [pageLength]="pageLength"
            *ngIf="'shipments' === activeListType"
          >
          </app-shipments-list>

          <app-parcels-list
            #parcelsListDatatables
            [userRole]="userModel?.role"
            [criteria]="criteria"
            [lengthMenu]="lengthMenu"
            [pageLength]="pageLength"
            *ngIf="'parcels' === activeListType"
          >
          </app-parcels-list>
        </div>
      </div>
    </div>
</div>
<div id="changeGrouppedStatus" uk-modal class="changeGrouppedStatus">
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>

    <div class="uk-modal-header">
      <h2 class="uk-modal-title">{{'change_status' | translate}}</h2>
    </div>

    <div class=" uk-modal-body">
      <div class="uk-width-1-1@m">
        <label>{{'choose_status' | translate}}</label>
        <select name="id_status_type" required class="uk-input" [(ngModel)]="statusModel.id_status_type">
          <option *ngFor="let statusType of statusTypes" value="{{statusType.id}}">{{statusType.displayed_name}}
          </option>
        </select>
      </div>

      <div class="uk-width-1-1@m">
        <label>{{'when' | translate}}</label>
        <input type="datetime-local" autocomplete="none" name="when"  [(ngModel)]="statusModel.when" required data-uk-timepicker class="uk-input">
      </div>

      <div class="uk-width-1-1@m">
        <label>{{'where' | translate}}</label>
        <input type="text" autocomplete="none" name="where" [(ngModel)]="statusModel.where" required class="uk-input">
      </div>

      <div class="uk-margin">
        <button class="uk-button uk-button-primary uk-width-1-1 uk-margin-top" (click)="setGroupStatuses()">{{'change_status' | translate}}</button>
      </div>
    </div>
  </div>
</div>
<div id="orderReportModal" uk-modal class="orderReportModal">
  <div class="uk-modal-dialog">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <div class="uk-modal-header">
      <h2 class="uk-modal-title">Wybierz rodzaj raportu</h2>
    </div>

    <div class="uk-modal-body">
      <div class="uk-width-1-1@m">
        <label>Rodzaj raportu</label>
        <select equired class="uk-input" [(ngModel)]="customReportForm.type">
          <option value="standard_from_filters">
            Raport przesyłek wedle filtrów
          </option>
          <option value="standard_from_filters_with_accounting">
            Przelicz i wygeneruj raport przesyłek wedle filtrów
          </option>
          <option value="invoiced_parcels_with_problem_return_to_client_decision">
            Błędnie naliczone odesłane przesyłki
          </option>
          <option value="employee_activity">
            Aktywność pracowników
          </option>
        </select>
      </div>
      <div class="uk-width-1-1@m mt-23"
           *ngIf="!['standard_from_filters', 'standard_from_filters_with_accounting'].includes(customReportForm.type)"
      >
        <div class="uk-grid">
          <div class="uk-width-1-2@m">
            <label>Od</label>
            <input class="uk-input" type="date" [(ngModel)]="customReportForm.start">
          </div>
          <div class="uk-width-1-2@m">
            <label>Do</label>
            <input class="uk-input" type="date" [(ngModel)]="customReportForm.end">
          </div>
        </div>
      </div>

      <div class="uk-margin">
        <button class="uk-button uk-button-primary uk-width-1-1 uk-margin-top" (click)="orderReport()">Zamów raport</button>
      </div>

    </div>
  </div>
</div>
